import inMemoryJWT from "./inMemoryJwt";

const apiUrl = process.env.REACT_APP_DOMAIN + "/api/admin";

const ROLES = {
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
  BILLER: "BILLER",
  FACILITY_OWNER: "FACILITY_OWNER",
};

// eslint-disable-next-line
const authProvider = {
  login: ({ username, password }) => {
    return fetch(`${apiUrl}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: username, password }),
    })
        .then((res) => {
          if (!res.ok) throw new Error(res.statusText);
          return res.json();
        })
        .then(({ data }) => {
          if (!data?.token) throw new Error("No token in response");
          inMemoryJWT.setToken(data.token, data.refresh_token || data.refreshToken);
        });
  },

  logout: () => {
    const token = inMemoryJWT.getToken();
    inMemoryJWT.ereaseToken();

    if (token) {
      fetch(`${apiUrl}/logout`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }).catch(() => {});
    }

    return Promise.resolve();
  },

  checkError: ({ status }) => {
    if (status === 403) {
      inMemoryJWT.ereaseToken();
      return Promise.reject();
    }
    return Promise.resolve();
  },

  checkAuth: () => {
    const token = inMemoryJWT.getToken();
    if (!token) return Promise.reject();

    if (!inMemoryJWT.isExpired()) return Promise.resolve();

    if (!inMemoryJWT.getRefreshToken()) {
      inMemoryJWT.ereaseToken();
      return Promise.reject();
    }

    return inMemoryJWT
        .refreshAccessToken()
        .then(() => {
          window.location.reload();
          return Promise.resolve();
        })
        .catch(() => Promise.reject());
  },

  getPermissions: () => {
    const token = inMemoryJWT.getToken();
    if (!token) return Promise.reject();
    return Promise.resolve(inMemoryJWT.getRoles());
  },

  checkAuthRoles: (permission) => {
    if (!(permission in ROLES)) {
      console.error(`Unknown role: ${permission}`);
      inMemoryJWT.ereaseToken();
      return Promise.reject();
    }
    return Promise.resolve();
  },
};

export default authProvider;